<ng-template #loaderTemplate>
  <div class="app-global-loader-panel">
    <mat-spinner mode="indeterminate" diameter="60" strokeWidth="3"></mat-spinner>
  </div>
</ng-template>
